import React from 'react'
import { cn } from '@strata-monorepo/shared-ui/utils/cn'
import { useStoreState } from '../../store/useStore'
import CallButton from '../../components/CallButton/CallButton'

interface CallCTAProps {
  className?: string
  /** Tracking context for the underlying phone link, set by the parent so events are attributable. */
  trackingLocation: string
  trackingName?: string
  trackingPosition?: string
}

/**
 * Phone call-to-action: a "Get help" label plus a phone icon and formatted number.
 * The label is hidden on mobile and shown from the @qm/qc container breakpoint up.
 * Renders nothing when no banner fuse config is available so the label never appears alone.
 */
export function CallCTA({
  className,
  trackingLocation,
  trackingName,
  trackingPosition,
}: CallCTAProps): React.ReactElement | null {
  const { bannerFuseConfig } = useStoreState((state) => state.phoneConfig)

  if (!bannerFuseConfig) {
    return null
  }

  return (
    <div
      className={cn('strata:flex strata:items-center', className)}
      data-testid='callCta'
    >
      <span className='strata:hidden strata:@qm/qc:inline strata:font-body strata:text-body-xs strata:font-bold strata:text-gray-700 strata:pr-2'>
        Get help
      </span>
      <CallButton
        text=''
        showIcon
        trackingLocation={trackingLocation}
        trackingName={trackingName}
        trackingPosition={trackingPosition}
        className='strata:flex strata:justify-center strata:items-center strata:gap-1 strata:px-0 strata:py-0 strata:font-title strata:text-title-tiny strata:font-bold strata:text-center strata:text-primary-500'
      />
    </div>
  )
}

export default CallCTA
